import { observable, action, runInAction, makeObservable } from 'mobx';
import { LogService } from '../services/data-services/LogService';

export abstract class BaseStore {
  constructor(logService: LogService) {
    this.logService = logService;
    makeObservable(this);
  }

  logService: LogService;

  @observable isLoading = false;

  @action protected fetchData = async <T>(fetchFn: () => Promise<T>, onSuccess?: (res: T) => void) => {
    try {
      this.isLoading = true;
      const data = await fetchFn();
      if (onSuccess) {
        runInAction(() => onSuccess(data));
      }
      return data;
    } finally {
      runInAction(() => (this.isLoading = false));
    }
  };
}
